import React from "react"
import {connect} from "react-redux";
import {history} from "../../../../history";
import {getFriendlyLobby, acceptFriendlyBattle, cancelFriendlyBattle}  from '@store/actions/socket/socket_actions';
import getResImgUrlById from '../../../../utility/getResImgUrlById';
import './custom.scss';
const soundClick ='/sounds/pvp_sounds/click.mp3';
const sound = '/sounds/notification/Notification_Sound_by_7_Days_Audio_version_2.wav';

const playClick = new Audio(soundClick)
const notificationAudio = new Audio(sound);


class NavbarNotifications extends React.PureComponent {
  state = {
    isOpenMessage: false,
  }

  componentDidMount(prevProps) {
      this.props.getFriendlyLobby()
  }
  componentDidUpdate(prevProps) {
    if(this.props.socket !== prevProps.socket || this.props.socket_user !== prevProps.socket_user){
        this.props.getFriendlyLobby()
    }
    if(this.props.needUpdateComponent !== prevProps.needUpdateComponent){
      this.props.getFriendlyLobby()
    }
    if(this.props.acceptFriendlyBattle !== prevProps.acceptFriendlyBattle && this.props?.battle_data?.battle.status === 'chose_deck'){
      // if (status === 'chose_deck') {
          history.push("/pvp/friendly");
      // }
    }
    if(this.props.friendly_lobby.length !== prevProps.friendly_lobby.length && this.props.friendly_lobby.length > prevProps.friendly_lobby.length) {
      this.props.friendly_lobby.map(msg=>{
      
        if(msg.wax_wallet !== this.props.user.userAccount){
          if (localStorage.getItem('mute') === "true") {
          notificationAudio.volume = (Number(localStorage.getItem("sound"))) 
          notificationAudio.play()
         }
        }
        return []
      })
    }
  }
   playClick = () => {
     if (localStorage.getItem('mute') === "true") {
      playClick.volume = (Number(localStorage.getItem("sound")))
      playClick.play(playClick.currentTime = 0)
    }
  }

  render() {
    const navbar_pvp_notifications = this.props.friendly_lobby && this.props.friendly_lobby.length ? this.props.friendly_lobby : []
    const my_notifications = navbar_pvp_notifications.filter(msg => {return msg.wax_wallet !== this.props.user.userAccount}) 
   
     if(my_notifications.length===0){
      this.setState({isOpenMessage: false})
     }

    return (
      <>
        <div className="img_notif" onClick={() => { this.playClick(); this.setState({isOpenMessage: !this.state.isOpenMessage})}}>
              {my_notifications.length > 0 && <span className='quantity-message'>{my_notifications.length}</span>}
              <svg><use href="/img/pvp_main_menu.svg#notif"/></svg>
          </div>
        {this.state.isOpenMessage && my_notifications.length > 0 && <div className={navbar_pvp_notifications.length >= 2 ? "messages_con pvp stylesBg2" : "messages_con pvp stylesBg"}>
        <div className='massage-scroll'>
          {my_notifications.map((msg, key)=>{
            return <div key={key} className='pvp-notification'>
              <p className="p_messages">You have invited of user: <span className="notification_wax">{msg.wax_wallet}</span> to play friendly battle</p>
              
               {(msg.resource_1 > 0 || msg.resource_2 > 0 || msg.resource_3 > 0 || msg.resource_4 > 0) && <div className="notification_container_res_img">
                  { msg.resource_1 > 0 && <span className="container_res_img"><img className="notification_res_img" src={getResImgUrlById(1)} alt="res"/> {msg.resource_1}</span> }
                  { msg.resource_2 > 0 && <span className="container_res_img"><img className="notification_res_img" src={getResImgUrlById(2)} alt="res"/> {msg.resource_2}</span> }
                  { msg.resource_3 > 0 && <span className="container_res_img"><img className="notification_res_img" src={getResImgUrlById(3)} alt="res"/> {msg.resource_3}</span> }
                  { msg.resource_4 > 0 && <span className="container_res_img"><img className="notification_res_img" src={getResImgUrlById(4)} alt="res"/> {msg.resource_4}</span> }
                </div>}

              <button type="button" className="btn_messages" onClick={() => {
                this.playClick()
                this.props.acceptFriendlyBattle(msg.id);
                this.setState({isOpenMessage: false})
                }}>ACCEPT</button>

              <button type="button" className="btn_messages" onClick={() => {
                this.playClick()
                this.props.cancelFriendlyBattle(msg.id)
                if(my_notifications.length === 1){
                  this.setState({isOpenMessage: false})
                }
                }}>DECLINE</button>
            </div>
          })}
        </div>
      </div>}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    socket_user: state.socket.socket_user,
    friendly_lobby: state.socket.friendly_lobby,
    needUpdateComponent: state.socket.needUpdateComponent,
    battle_data: state.socket.battle_data,
  }
}
export default connect(mapStateToProps, {getFriendlyLobby, acceptFriendlyBattle, cancelFriendlyBattle})(NavbarNotifications)